import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import './css/global.scss';
import './css/bootstrap.min.css';
import './css/viking.css';
import { createRoot } from 'react-dom/client';
import { logInfo } from 'utils/logger';
import { MSAL_CONFIG } from './common/AuthConfig';
import { APP_TITLE } from './common/Constants';
import configureStore from './configureStore';
import App from './pages/App';

const store = configureStore();
document.title = APP_TITLE;

const msalInstance = new PublicClientApplication(MSAL_CONFIG);
(async () => {
  await msalInstance.initialize();
  let account = msalInstance.getActiveAccount();
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    [account] = msalInstance.getAllAccounts();
    msalInstance.setActiveAccount(account);
  }

  msalInstance.addEventCallback((event) => {
    logInfo({ logData: event, name: 'index.jsx - msalInstanc.addEventCallback' });
    if (event.error) {
      if (event.error.errorCode === 'authority_mismatch') {
        msalInstance.logoutRedirect({ ...MSAL_CONFIG, account: msalInstance.getActiveAccount() });
      }
    }
    const allowedTypes = [EventType.ACQUIRE_TOKEN_SUCCESS, EventType.SSO_SILENT_SUCCESS, EventType.LOGIN_SUCCESS];
    if (allowedTypes.includes(event.eventType) && event.payload.account) {
      ({ account } = event.payload);
      if (account) {
        msalInstance.setActiveAccount(account);
      }
    }
  });

  const domNode = document.getElementById('root');
  const root = createRoot(domNode);

  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </BrowserRouter>
    </Provider>,
  );
})();
